export default class {
    constructor() {
        let newPage = 1;
        document
            .querySelector("#whatsOnLoad")
            ?.addEventListener("click", (e) => {
                // Prevent refresh
                e.preventDefault;
                // Change text value on button
                e.target.innerHTML = "Events loading...";
                // Get date & type from url
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const month = urlParams.get('month');
                const type = urlParams.get('type');
                // Call load more
                loadMore(newPage + 1, month, type, e);
                // Increase pagination
                newPage++;
            });

        function loadMore(paged, month, type, e) {
            jQuery.ajax({
                type: "post",
                url: `${window.location.origin}/wp-admin/admin-ajax.php`,
                dataType: "json",
                data: {
                    action: "load_more_events_paid",
                    paged,
                    month,
                    type
                },
                complete: function (response) {
                    if (response.responseText != 0) {
                        jQuery(".whats-on ul.products").append(
                            response.responseText
                        );
                        e.target.innerHTML = "Load more events";
                    } else {
                        e.target.disabled = true;
                        e.target.innerHTML = "All events loaded";
                    }
                },
            });
        }
    }
}
